const TravelCalculatorFromLibrary = React.lazy(() => import('@carbonclick/travel-calculator-library/dist/travel-calculator-lib'));


import React from 'react';

const config = {
    API_KEY: process.env.API_KEY, 
    API_URL: process.env.API_URL,
    STRIPE_CLIENT_ID: process.env.STRIPE_CLIENT_ID,
    MYCC_BASE_URL: process.env.MY_CC_URL,
    HOTJAR_SITE_ID: '2265907'
}

const TravelCalculator = ({merchantCode}) => {

    return (
      <React.StrictMode>
        <div className={"w-100 h-100 bg-white translate-dynamic"} >
          <React.Suspense fallback={<div></div>}>
            <TravelCalculatorFromLibrary
              config={config}
              merchantCode={merchantCode}
            />
          </React.Suspense>
        </div>
      </React.StrictMode>
    );
};

export default TravelCalculator;
